import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { Title } from '@lib/components/v2/Title';
import Page from '@lib/components/v2/Page';
import { localizedString } from '@languages';
import Animation, { useAnimationUrls } from '@components/Animation';
import { FLOW_V2_EXTRA_FR_TIPS, REDUCE_FACE_ANIMATION_SIZE } from '@spotMobileConfig';
import classes from './Prepare.style.module.scss';

const Prepare = ({ selfie = false, onStart, onGoBack }) => {
  const { animationUrls } = useAnimationUrls();
  let size = {};
  if (REDUCE_FACE_ANIMATION_SIZE && REDUCE_FACE_ANIMATION_SIZE > 0) {
    size = {
      width: `${100 - REDUCE_FACE_ANIMATION_SIZE}%`,
      margin: '0 auto'
    };
  }

  const buttons = [
    {
      label: localizedString('back'),
      variant: 'transparent',
      onClick: onGoBack,
      dataTestId: 'face-back'
    },
    {
      label: localizedString('continue'),
      type: 'submit',
      onClick: onStart,
      dataTestId: 'face-continue'
    }
  ];
  return (
    <Page hideLogo={false} buttons={buttons} className={classes.wrapper} ariaLive="assertive">
      <Title
        data-testid="face-heading"
        title={localizedString('faceVerification.FLOW_V2_FR_TIPS_HEADING')}
      />
      <div data-testid="face-instruction">
        {parse(
          selfie
            ? localizedString('faceVerification.FLOW_V2_FR_TIPS_SELFIE_DESCRIPTION')
            : localizedString('faceVerification.FLOW_V2_FR_TIPS_DESCRIPTION')
        )}

        <div
          style={size}
          className={classes['animation-container']}
          data-testid="face-instruction-img"
        >
          <Animation animationUrl={animationUrls.FACE_ID} />
        </div>
        {FLOW_V2_EXTRA_FR_TIPS && <p>{FLOW_V2_EXTRA_FR_TIPS}</p>}
      </div>
    </Page>
  );
};

Prepare.propTypes = {
  onStart: PropTypes.func,
  onGoBack: PropTypes.func,
  selfie: PropTypes.bool
};

Prepare.defaultProps = {
  onStart: () => {}
};

export default Prepare;
